<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<nz-page-header class="page-header">
  <nz-page-header-title>
    <span>
      <i class="fa-light fa-list-tree"></i>
      {{ 'Categories'| translate }}
    </span>
  </nz-page-header-title>
  <nz-page-header-extra>
    <nz-space nzDirection="horizontal">
      <ng-container *nzSpaceItem>
        <!-- <button
          *isAuthorized="'Admin,Editor'"
          nz-button
          nzType="primary"
          [routerLink]=""
          (click)="btnNewCategoryClicked()"
        >
          <i nz-icon nzType="plus-circle"></i>
          {{ "New Category" }}
        </button> -->
        <div *ngIf="selectedKey != null" class="content-footer">
          <nz-space nzDirection="horizontal" nzAlign="center" nzSize="small">
          <ng-container *nzSpaceItem>
          <button
            *ngIf="selectedKey === 0"
            nz-button
            nzType="primary"
            [routerLink]=""
            (click)="CreateNewCategory()"
          >
            <i nz-icon nzType="plus-circle"></i>
            {{ 'Save' | translate}}
          </button>
        </ng-container>
        <ng-container *nzSpaceItem>
          <button
            *ngIf="selectedKey > 0"
            nz-button
            nzType="primary"
            [routerLink]=""
            (click)="UpdateCategory()"
          >
            <i nz-icon nzType="plus-circle"></i>
            {{ 'Update' | translate }}
          </button>
        </ng-container>
        <ng-container *nzSpaceItem>
          <button nz-button *ngIf="selectedKey > 0" [disabled]="!canRemove" nzType="default" (click)="RemoveCategory()">
            {{ 'Remove'| translate }}
          </button>
        </ng-container>
      </nz-space>
        </div>
      </ng-container>
      <ng-container>
        <button *nzSpaceItem nz-button nzType="default" (click)="onRefresh()">
          {{ 'Refresh' | translate }}
        </button>
      </ng-container>
    </nz-space>
  </nz-page-header-extra>
</nz-page-header>
<div nz-row class="categories-main-container">
  <div nz-col [nzLg]="6"  class="categories-tree">

    <div class="button-group">
      <button nz-button nzType="primary" nzBlock
       (click)="AddRootCategory()">{{'Add Root Category' | translate}}</button>
      <button 
        nz-button 
        nzType="default" 
        nzBlock 
        [disabled]="selectedKey == null || selectedKey === 0" 
        (click)="AddSubCategory()">
        {{'Add Sub Category' | translate}}
      </button>
    </div>
    <nz-input-group class="search-group">
      <input 
        type="text" 
        nz-input 
        [placeholder]="'Search for category' | translate" 
        [(ngModel)]="searchValue" />
      <button nz-button nzType="default" class="search-icon">
        <span nz-icon nzType="search"></span>
      </button>
    </nz-input-group>
    
  
    <!-- <nz-row nzGutter="16">
      <nz-col nzSpan="12">
        <a nz-button nzType="primary" nzBlock (click)="AddRootCategory()">Add Root category</a>
      </nz-col>
      <nz-col nzSpan="12">
        <a nz-button nzType="default"  nzBlock [disabled]="selectedKey == null || selectedKey === 0" (click)="AddSubCategory()">Add Sub-category</a>
      </nz-col>
       <nz-col nzSpan="8">
        <a nz-button nzBlock [disabled]="!canRemove" (click)="RemoveCategory()">Remove</a>
      </nz-col> 
    </nz-row>
   <nz-input-group [nzSuffix]="suffixIcon">
      <input type="text" nz-input placeholder="Search" [(ngModel)]="searchValue" />
    </nz-input-group>
    <ng-template #suffixIcon>
      <span nz-icon nzType="search" nzTheme="outline"></span>
    </ng-template>  -->


    
  
  <ng-template #switcherIconTemplate let-node>
    <i nz-icon [nzType]="node.isExpanded ? 'caret-down' : 'caret-right'"></i>
  </ng-template>

   <nz-tree
    *ngIf="!isLoading"
    nzBlockNode
    nzAsyncData
    nzHideUnMatched
    class="custom-scrollbar"
    [nzCheckStrictly]="false"
    [nzData]="nodes"
    (nzClick)="activeNode($event)"
    nzDraggable
    (nzOnDragEnd)="CategoryDragEnd($event)"
    [nzSearchValue]="searchValue"
  >
    <ng-template #nzTreeTemplate let-node>
      <i nz-icon [nzType]="node.isLeaf ? 'folder' : 'folder-open'" class="ant-tree-switcher-icon"></i>
      {{ node.title }}
    </ng-template>
  </nz-tree> 
    <nz-skeleton [nzActive]="true" *ngIf="isLoading === true"></nz-skeleton>
  </div>
  <div
    nz-col
    [nzLg]="17"
    style="margin-left: 15px; max-height: 80vh; "
    *isAuthorized="'Admin,Editor'"
  >
  <!-- overflow-y: auto -->
    <app-form-category
      *ngIf="selectedKey != null"
      #formComponent
      [formGroup]="formGroup"
      [mode]="'create'"
      [componentModel]="componentModel"
      [categories]="data"
      [categoryId]="categoryId"
      (submitChanges)="submit()"
      (attributeGroupsLoaded)="onAttributeGroupsLoaded($event)"
       (listPayload)="handleDataFromChild($event)"
    ></app-form-category>
    <!-- <div *ngIf="selectedKey != null" class="content-footer">
      <button
        *ngIf="selectedKey === 0"
        nz-button
        nzType="primary"
        [routerLink]=""
        (click)="CreateNewCategory()"
      >
        <i nz-icon nzType="plus-circle"></i>
        {{ "Save" }}
      </button>
      <button
        *ngIf="selectedKey > 0"
        nz-button
        nzType="primary"
        [routerLink]=""
        (click)="UpdateCategory()"
      >
        <i nz-icon nzType="plus-circle"></i>
        {{ "Update" }}
      </button>
      <button nz-button nzType="default" (click)="onRefresh()">
        {{ "Cancel" }}
      </button>
    </div> -->
  </div>
</div>

<ng-template #nzExpndTemplate let-node let-origin="origin">
  <span class="expand-icon">
    <span
      *ngIf="!node.isLeaf"
      nz-icon
      [nzType]="node.isExpanded ? 'caret-down' : 'caret-right'"
    ></span
  ></span>
</ng-template>

<ng-template #nzTreeTemplate let-node let-origin="origin">
  <span class="custom-node">
    <span *ngIf="!node.isLeaf" style="width: 50%">
      <nz-space>
        <span
          *nzSpaceItem
          nz-icon
          [nzType]="node.isExpanded ? 'folder-open' : 'folder'"
          nzTheme="fill"
          class="folder-node"
        ></span>
        <span *nzSpaceItem>
          <nz-space>
            <span *nzSpaceItem>{{ node.title }}</span>
            <span *nzSpaceItem
              ><nz-tag nzColor="geekblue">{{
                origin.productsCount
              }}</nz-tag></span
            >
          </nz-space>
        </span>
      </nz-space>
    </span>
    <span *ngIf="node.isLeaf">
      <span nz-icon nzType="file" class="file-node"></span>
      <span class="file-name">
        <span>
          <nz-space>
            <span *nzSpaceItem>{{ node.title }}</span>
            <span *nzSpaceItem
              ><nz-tag nzColor="blue">{{ origin.productsCount }}</nz-tag></span
            >
          </nz-space>
        </span>
      </span>
    </span>
    <span style="text-align: right">
      <div style="float: right" class="node-control">
        <nz-button-group *isAuthorized="'Admin,Editor'">
          <button
            nz-button
            nz-dropdown
            nzTrigger="click"
            [nzDropdownMenu]="menu"
            nzPlacement="bottomRight"
          >
            <span nz-icon nzType="ellipsis"></span>
          </button>
        </nz-button-group>
      </div>
    </span>
  </span>
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu>
      <li nz-menu-item (click)="AddSubNode(node)">{{'Add Sub Category' | translate}}</li>
      <li nz-menu-divider></li>
      <li
        nz-menu-item
        nz-popconfirm
        nzPopconfirmTitle="Are you sure delete this category?"
        (nzOnConfirm)="RemoveNode(node)"
      >
        {{'Remove' | translate}}
      </li>
    </ul>
  </nz-dropdown-menu>
</ng-template>




